import ButtonComman from '../ButtonComponents/ButtonComman';
import MainTitle from '../MainTitle/MainTitle';
import styles from './CallToAction.module.css';

function CallToAction() {
  return (
    <section className={styles.callToAction}>
      <MainTitle
        title="Ready to Elevate Your Wardrobe? "
        subTitleLine="“Make a sustainable choice. Wear stunning outfits without
contributing to the fast fashion cycle."
      />

      <div className={styles.ctaButtons}>
        <ButtonComman
          title="Start Your Free Trial"
          className="primaryButton"
          arrowIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-arrow-right h-4 w-4"
            >
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          }
        />
        <ButtonComman navigateTo="/s" title="View Collection" className="secondaryButton" />
      </div>
    </section>
  );
}

export default CallToAction;
